module.exports = __webpack_public_path__ + "static/media/students-icon-4.ed9534ac.svg";